export const STATUS_LABELS = {
  ACTIVE: "Actif",
  DISABLED: "Désactivé",
  
  CREATED: "Créé",
  PENDING: "En attente",
  DELIVERED: "Livré",
  REVERSED: "Renvoyé",
  CANCELED: "Annulé",
  SUCCESS: "Réussi",
  REJECTED: "Rejeté",

  UNKNOWN: "Non défini",
};

export const STATUS_COLORS = {
  ACTIVE: "green",
  DISABLED: "red",

  CREATED: "blue",
  PENDING: "orange",
  DELIVERED: "teal",
  REVERSED: "purple",
  CANCELED: "gray",
  SUCCESS: "green",
  REJECTED: "red",

  UNKNOWN: "default",
};